import {
  ARIA_ESCALATION_TARGET_TYPE,
  getAriaNotificationMeta,
} from '../constants/ariaNotificationTypes';
import { getEventNotificationMeta } from '../constants/eventNotificationTypes';
import {
  getCommunityNotificationMeta,
  PARTNER_GROUP_CHAT_MESSAGE_TARGET_TYPE,
  PARTNER_GROUP_JOIN_REQUEST_TARGET_TYPE,
  PARTNER_GROUP_MEMBER_AUTO_JOINED_TARGET_TYPE,
  PARTNER_GROUP_MEMBER_JOINED_TARGET_TYPE,
} from '../constants/communityNotificationTypes';
import {
  getVettingNotificationMeta,
  VETTING_APPLICATION_TARGET_TYPE,
} from '../constants/vettingNotificationTypes';
import {
  getPartnerNotificationMeta,
  PARTNER_PROFILE_TARGET_TYPE,
} from '../constants/partnerNotificationTypes';
import { PARTNER_EVENT_TARGET_TYPE } from './portalNotificationRouting';

const humanizeTargetType = (targetType) =>
  String(targetType || '')
    .trim()
    .split('_')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');

/** Shared title for inbox rows and push (prefer notification type over targetType). */
export const resolveNotificationTitle = ({ targetType, type }) => {
  const normalizedType = String(type || '')
    .trim()
    .toLowerCase();
  const normalizedTarget = String(targetType || '')
    .trim()
    .toLowerCase();

  const communityMeta = getCommunityNotificationMeta(normalizedType);
  if (communityMeta?.label) {
    return communityMeta.label;
  }

  const eventMeta = getEventNotificationMeta(normalizedType);
  if (eventMeta?.label) {
    return eventMeta.label;
  }

  const vettingMeta = getVettingNotificationMeta(normalizedType);
  if (vettingMeta?.label) {
    return vettingMeta.label;
  }

  const partnerMeta = getPartnerNotificationMeta(normalizedType);
  if (partnerMeta?.label) {
    return partnerMeta.label;
  }

  const ariaMeta = getAriaNotificationMeta(normalizedType);
  if (ariaMeta?.label) {
    return ariaMeta.label;
  }

  const communityTargetMeta = getCommunityNotificationMeta(normalizedTarget);
  if (communityTargetMeta?.label) {
    return communityTargetMeta.label;
  }

  const eventTargetMeta = getEventNotificationMeta(normalizedTarget);
  if (eventTargetMeta?.label) {
    return eventTargetMeta.label;
  }

  const vettingTargetMeta = getVettingNotificationMeta(normalizedTarget);
  if (vettingTargetMeta?.label) {
    return vettingTargetMeta.label;
  }

  const partnerTargetMeta = getPartnerNotificationMeta(normalizedTarget);
  if (partnerTargetMeta?.label) {
    return partnerTargetMeta.label;
  }

  const ariaTargetMeta = getAriaNotificationMeta(normalizedTarget);
  if (ariaTargetMeta?.label) {
    return ariaTargetMeta.label;
  }

  if (normalizedTarget === PARTNER_GROUP_JOIN_REQUEST_TARGET_TYPE) {
    return 'Community join request';
  }

  if (normalizedTarget === PARTNER_GROUP_CHAT_MESSAGE_TARGET_TYPE) {
    return 'Community message';
  }

  if (normalizedTarget === PARTNER_GROUP_MEMBER_AUTO_JOINED_TARGET_TYPE) {
    return 'Member joined via event';
  }

  if (normalizedTarget === PARTNER_GROUP_MEMBER_JOINED_TARGET_TYPE) {
    return 'New community member';
  }

  if (normalizedTarget === PARTNER_EVENT_TARGET_TYPE) {
    return 'Partner event';
  }

  if (normalizedTarget === VETTING_APPLICATION_TARGET_TYPE) {
    return 'New vetted user';
  }

  if (normalizedTarget === PARTNER_PROFILE_TARGET_TYPE) {
    return 'Partner onboarding submitted';
  }

  if (normalizedTarget === ARIA_ESCALATION_TARGET_TYPE) {
    return 'Aria handoff requested';
  }

  if (normalizedTarget) {
    return humanizeTargetType(normalizedTarget);
  }

  return 'Notification';
};
